import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnimatedButton from "../AnimatedButton/AnimatedButton";

const rubikfont = {
    fontFamily: "Rubik, san-serif"
};

const Layout2 = ({ data }) => {
    const products = data?.product_id || [];
    const featuredProduct = products[0];
    const gridProducts = products.slice(1, 5);
    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
        window.scrollTo(0, 0);
    };

    if (!featuredProduct) return null;

    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "#f8f8f8",
                py: 6,
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "300px",
                    height: "300px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(34,34,34,0.05), transparent)",
                    transform: "translate(30%, -30%)",
                }}
            />
            <Container>
                {/* Section Header */}
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    {/* header title */}
                    <Typography
                        sx={{
                            fontSize: { xs: "32px", sm: "48px", md: "56px" },
                            color: "#222",
                            ...rubikfont,
                            fontWeight: 900,
                            lineHeight: 1.1,
                            letterSpacing: "3.5px",
                            textTransform: "uppercase"
                        }}
                    >
                        {data?.title || "Trending Now"}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "16px",
                            color: "#666",
                            ...rubikfont,
                        }}
                    >
                        Discover the most popular products this month
                    </Typography>
                </Box>

                {/* Trending Grid Layout */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                        gap: 4,
                    }}
                >
                    {/* Large Featured Product - Left */}
                    <Box
                        onClick={() => handleProductClick(featuredProduct._id)}
                        sx={{
                            position: "relative",
                            borderRadius: 3,
                            overflow: "hidden",
                            height: { xs: 400, md: 600 },
                            cursor: "pointer",
                            transition: "all 0.4s ease",
                            "&:hover": {
                                transform: "scale(1.02)",
                                "& .featured-image": {
                                    transform: "scale(1.1)",
                                },
                                "& .featured-overlay": {
                                    bgcolor: "rgba(0,0,0,0.5)",
                                },
                            },
                        }}
                    >
                        <img
                            src={featuredProduct.product_images?.[0] || "https://via.placeholder.com/600"}
                            alt={featuredProduct.title}
                            className="featured-image"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                transition: "transform 0.6s ease",
                            }}
                        />
                        <Box
                            className="featured-overlay"
                            sx={{
                                position: "absolute",
                                inset: 0,
                                bgcolor: "rgba(0,0,0,0.4)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                p: 5,
                                transition: "all 0.4s ease",
                            }}
                        >

                            {featuredProduct.b2b_discountValue && (
                                <Box
                                    sx={{
                                        bgcolor: "white",
                                        color: "black",
                                        border: "1px solid black",
                                        px: 2.5,
                                        py: 0.8,
                                        fontSize: "11px",
                                        letterSpacing: "2px",
                                        fontWeight: 700,
                                        display: "inline-block",
                                        mb: 2,
                                        ...rubikfont,
                                        alignSelf: "flex-start",
                                    }}
                                >
                                    {featuredProduct.b2b_discountType === "percentage"
                                        ? `${featuredProduct.b2b_discountValue}% OFF`
                                        : `₹${featuredProduct.b2b_discountValue} OFF`
                                    }
                                </Box>)}
                            
                            <Typography
                                sx={{
                                    color: "white",
                                    fontSize: { xs: "28px", md: "36px" },
                                    fontWeight: 700,
                                    mb: 2,
                                    ...rubikfont,
                                    lineHeight: 1.2,
                                }}
                            >
                                {featuredProduct.title}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                {/*b2b_sellingPrice */}
                                <Typography
                                    sx={{
                                        color: "white",
                                        fontSize: "32px",
                                        fontWeight: 700,
                                        ...rubikfont,
                                    }}
                                >
                                    ₹{featuredProduct.b2b_sellingPrice}
                                </Typography>
                                {featuredProduct.b2c_mrp && (
                                    <Typography
                                        sx={{
                                            color: "rgba(255,255,255,0.7)",
                                            fontSize: "20px",
                                            textDecoration: "line-through",
                                            ...rubikfont,
                                        }}
                                    >
                                        ₹{featuredProduct.b2c_mrp}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    {/* Right Side - Grid of Smaller Products */}
                   <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 3,
  }}
>
  {gridProducts.map((product, index) => (
    <Box
      key={product._id || index}
      onClick={() => handleProductClick(product._id)}
      sx={{
        bgcolor: "white",
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        transition: "0.4s",
        cursor: "pointer",
        "&:hover": { transform: "translateY(-12px)" },
      }}
    >
      {/* Image Wrapper */}
      <Box sx={{ position: "relative" }}>
        <Box
          component="img"
          src={product.product_images?.[0]}
          alt={product.title}
          sx={{
            width: "100%",
            height: 180,
            objectFit: "cover",
          }}
        />

        {/* B2B Discount Badge – TOP RIGHT */}
        {product.b2b_discountValue && (
          <Box
            sx={{
              position: "absolute",
              top: 10,
               left: 10, 
              bgcolor: "#1c79afff",
              color: "white",
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              fontSize: { xs: "11px", sm: "12px", md: "13px" },
              fontWeight: 600,
              zIndex: 2,
              boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
              ...rubikfont,
            }}
          >
            {product.b2b_discountType === "percentage"
              ? `${product.b2b_discountValue}% OFF`
              : `₹${product.b2b_discountValue} OFF`}
          </Box>
        )}
      </Box>

      {/* Content */}
      <Box sx={{ p: 2 }}>
        <Typography sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
          {product.title}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              color: "#222",
              ...rubikfont,
            }}
          >
            ₹{product.b2b_sellingPrice}
          </Typography>

          {product.b2c_mrp && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "red",
                textDecoration: "line-through",
                ...rubikfont,
              }}
            >
              ₹{product.b2c_mrp}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  ))}
</Box>

                </Box>

                {/* View All Button */}
                <Box sx={{ textAlign: "center", mt: 6, display: "flex", gap: 3, flexWrap: "wrap", justifyContent: "center" }}>
                    <AnimatedButton text="View All Trending →" onClick={() => navigate('/search', { state: { layoutId: data._id, title: data.title } })} />
                </Box>

            </Container>
        </Box>
    );
};

export default Layout2;
